export const MAP_CONSTANTS = {
  PAGINATION: {
    DEFAULT_LIMIT: 500,
    TIMELINE_LIMIT: 5000,
  },
  MONTHS: {
    LABELS: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
  POPUP: {
    MAX_WIDTH: 360,
    MIN_WIDTH: 360,
    MAX_HEIGHT_OFFSET: 176,
  },
} as const;
